export const ADMIN_SETTINGS = {
    BRAND_SETTINGS: "brand-settings",
    API_MANAGEMENT: "apimanagement",
    DELIVERY_WINDOWS: "deliverywindows",
    CUSTOMER_USER_GROUPS: "customer-user-groups",
    INVENTORY_SETTINGS: "inventory-settings",
    ORDER_RULES: "order-rules",
    ORDER_SETTINGS: "order-settings",
    ORDER_EXPORT_TEMPLATES: "custom_templates",
    STITCHLABS_INTEGRATION: "stitchlabsmanagement",
    MANAGE_MARKETPLACE_PROFILE: "managemarketplaceprofile",
    ONLINE_TRADESHOW_SETUP: "online-trade-show",
    MANAGE_SHIPPING: "shipping-management",
    MANAGE_BRAND_LOGOS: "logos_management",
    WATERMARKING: "watermarking",
    MANAGE_PAYMENT_PROCESSING: {
        LINK: "paymentprocessing-link",
        ADD_MY_OWN_PROCESSOR: "add-byo",
        SIGN_FOR_WEPAY: "add-wepay",
        PAYMENT_ACCOUNT: "payment-account",
    },
    PAYMENT_HISTORY: {
        LINK: "paymenthistory-link",
        TITLE: "payment-history-title",
        START_DATE: "payment-history-start-date",
        END_DATE: "payment-history-end-date",
        EXPORT: "payment-history-export",
    },
    DASHBOARD_LOGO: "dashboard-logo",
    PRODUCT_PLACEHOLDER: "product-placeholder",
    PDF_LOGO: "pdf-logo",
    LINESHEET_HERO: "linesheet-hero",
    TERMS_MANAGEMENT: {
        ADD: "add-legal-file",
        ROW: "legal-file-row-",
        COMPANIES: "legal-file-companies",
        DELETE: "delete-legal-file",
        RENAME: "rename-legal-file",
        REPLACE: "replace-legal-file",
        DOWNLOAD: "download-legal-file",
        UPLOAD: "upload-legal-files",
        UPLOAD_ERROR: "upload-legal-files-error",
    },
    DATA_TAB: "data-tab",
    IMAGERY_TAB: "imagery-tab",
    PROMOTIONS_TAB: "promotions-tab",
    USERS_TAB: "users-tab",
};
